import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-detail-factoid',
    templateUrl: './detail-factoid.component.html',
    styleUrls: ['./detail-factoid.component.scss'],
    standalone: false,
})
export class DetailFactoidComponent {
    @Input()
    public title?: string;

    @Input()
    public data?: Array<string>;
}
